import {Log, LogGroup, AsyncClient, PutLogsRequest} from 'tencentcloud-cls-sdk-js-web'
class TFWebLog{
    // 主题ID
    set topic_id(topic_id){
        this._topic_id = topic_id
    }

    get topic_id(){
        return this._topic_id
    }

    set fans_id(fans_id){
        this._fans_id = fans_id
    }

    get fans_id(){
        return this._fans_id
    }

    set org_id(org_id){
        this._org_id = org_id
    }

    get org_id(){
        return this._org_id
    }

    // 通用字段
    set common_data(common_data){
        this._common_data = common_data
    }

    get common_data(){
        return this._common_data
    }

    set endpoint(endpoint){
        this._endpoint = endpoint
    }

    get endpoint(){
        return this._endpoint
    }

    set topic_list(topic_list){
        this._topic_list = topic_list
    }

    get topic_list(){
        return this._topic_list
    }
    // 会话id  关闭页面后重置
    set sessionID(sessionId){
        this._sessionId = sessionId
    }

    get sessionID(){
        return this._sessionId
    }

    //localStorage  同一个项目下面 缓存 不清除不会变
    get UUID(){
        if(window.localStorage.getItem("tengface_log_uuid")){
            this._UUID = window.localStorage.getItem("tengface_log_uuid")
            return window.localStorage.getItem("tengface_log_uuid")
        }else{

            this._UUID = uuid
            return uuid
        }
    }

    static getInstance(){
		//判断是否之前创建过实例，有的话就return 没有就创建一个
		if(!this._instance){
            this._instance = new TFWebLog()
            this._instance._topic_id = "5306a7a8-586b-46af-9304-f6b090062924"
            this._instance._common_data = {}
            this._instance._org_id = 0
            if(window.localStorage.getItem("tengface_log_uuid")){
                this._instance._UUID = window.localStorage.getItem("tengface_log_uuid")
            }else{
                const uuid = this._instance.randomString(32);
                window.localStorage.setItem('tengface_log_uuid',uuid)
                this._instance._UUID = uuid
            }
            this._instance._sessionId = this._instance.randomString(32)
            this._instance._endpoint = "https://ap-guangzhou.cls.tencentcs.com"
            this._instance._topic_list = ["5306a7a8-586b-46af-9304-f6b090062924","861ae792-e310-44dc-a41f-5e97e1db55af","1dfb7976-6e2e-420c-85ca-8bff69337e3c"]
        }
		return this._instance
	}

    init(terminal_type,fans_id,extendData) {
        // 1 H5  2 web  3 老师端  4 跟进页  5小程序 6 安卓 7 ios 8 学员端
        this._terminal_type = terminal_type;
        if(fans_id){
            this._fans_id = fans_id
        }else{
            this._fans_id = 0
        }

        if(extendData){
            if(extendData.endpoint){
                this._endpoint = endpoint
            }
            if(extendData.topicList){
                this._topic_list = extendData.topicList
            }
        }

    }
    //重写console.error
    /**
     * 
     * @param {*} code  错误码配合业务使用
     * @param {*} type  1:埋点日志 2:错误日志 3:使用日志
     */
    addConsoleErrorListener(code,type){
        let _this = this
        const originalError = window.console.error;
        window.console.error = function(...args){
            let msg = args.join("")
            const _code = code || 10110
            const _type = type || 2
            _this.putLogs(_code,_type,{responseData:msg})
            originalError.apply(window.console, args);
        }
    }

    setCommonKeyValue(key,value){
        this._common_data[key] = value
    }

    // 提交日志接口
    putLogs(code,type,data){

        if(!code || !type){
            return false
        }

        if(type){
            this._topic_id = this._topic_list[type - 1]
        }

        var postData = {...data}

        postData.topic_id = this._topic_id

        postData.code = code + ""

        postData.type = type

        postData.fans_id = this._fans_id

        postData.terminal_type = this._terminal_type

        postData.sessionId = this._sessionId

        postData.UUID = this._UUID

        postData.userAgent = navigator.userAgent

        postData.domainUrl = window.location.href

        postData.time = new Date().valueOf()

        postData.org_id = this._org_id
        // 通用字段
        for (let i in this._common_data) {
            postData[i] = this._common_data[i]
        }


        if(data.sendType && data.sendType == "immediately"){
            this._logGroup = new LogGroup()
            let log = new Log(Date.now())
            this.logAddData(log,postData)
            this._logGroup.addLog(log)
            this.sendRequest()
            return
        }

        // 这里做节流处理
        if(this._time){
            // 存在定时器
            let log = new Log(Date.now())
            this.logAddData(log,postData)
            if(!this._logGroup){
                this._logGroup = new LogGroup()
            }
            this._logGroup.addLog(log)
        }else{
            // 不存在定时器,创建定时器并且发送
            this._time = setTimeout(()=>{
                if(this._logGroup){
                    this.sendRequest()
                }
                this._time = null
            },3000);
            this._logGroup = new LogGroup()
            let log = new Log(Date.now())
            this.logAddData(log,postData)
            this._logGroup.addLog(log)
            this.sendRequest()
        }
    }

    logAddData(log,postData){
        for (let i in postData) {
            let obj = postData[i];
            if(typeof obj === "object"){
                try {
                    obj = JSON.stringify(obj)
                } catch (error) {
                    console.log(error)
                }
            }
            if(typeof obj == "string"){
                obj = obj.replace("#","^*")
                obj = obj.replace("&","^^")
            }
            log.addContent(i,obj + "")
        }
    }

    sendRequest(){
        let client = new AsyncClient({
            endpoint: this._endpoint,
            retry_times: 3,
        });
        let request = new PutLogsRequest(this.topic_id, this._logGroup);
        client.PutLogs(request).then(()=>{
            this._logGroup = null
        },(error)=>{
            console.log("上传日志报错")
            this.putLogs(10004,2,error)
        })
    }

    randomString(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
}

export default TFWebLog


// WEBPACK FOOTER //
// ./src/components/TFWebLog/js/TFWebLog/index.js